import { Model, IModelAttributes, attribute, entity } from 'Models/Model';
import * as Models from 'Models/Entities';
import { makeObservable, observable } from 'mobx';

export interface ITransactionDiscountAttributes extends IModelAttributes {
	transactionId: string;
	discountId: string;

	transaction: Models.TransactionEntity | Models.ITransactionEntityAttributes;
	discount: Models.DiscountEntity | Models.IDiscountEntityAttributes;
	discountAmount: number;
}

@entity('TransactionDiscount')
export default class TransactionDiscount extends Model implements ITransactionDiscountAttributes {
	@observable
	@attribute()
	public transactionId: string;

	@observable
	@attribute()
	public discountId: string;

	@observable
	@attribute({ isReference: true })
	public transaction: Models.TransactionEntity;

	@observable
	@attribute({ isReference: true })
	public discount: Models.DiscountEntity;

	@observable
	@attribute()
	public discountAmount: number;

	constructor(attributes?: Partial<ITransactionDiscountAttributes>) {
		super(attributes);

		makeObservable(this);

		if (attributes) {
			if (attributes.transactionId) {
				this.transactionId = attributes.transactionId;
			}
			if (attributes.discountId) {
				this.discountId = attributes.discountId;
			}

			if (attributes.transaction) {
				if (attributes.transaction instanceof Models.TransactionEntity) {
					this.transaction = attributes.transaction;
					this.transactionId = attributes.transaction.id;
				} else {
					this.transaction = new Models.TransactionEntity(attributes.transaction);
					this.transactionId = this.transaction.id;
				}
			} else if (attributes.transactionId !== undefined) {
				this.transactionId = attributes.transactionId;
			}

			if (attributes.discount) {
				if (attributes.discount instanceof Models.DiscountEntity) {
					this.discount = attributes.discount;
					this.discountId = attributes.discount.id;
				} else {
					this.discount = new Models.DiscountEntity(attributes.discount);
					this.discountId = this.discount.id;
				}
			} else if (attributes.discountId !== undefined) {
				this.discountId = attributes.discountId;
			}
			if (attributes.discountAmount) {
				this.discountAmount = attributes.discountAmount;
			}
		}
	}
}
